// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var WebEnvVars = require("../WebEnvVars.bs.js");

var deployEnv = WebEnvVars.vars.deployEnv;

function WebComponents_JobcasePixel(Props) {
  if (deployEnv !== 3) {
    return null;
  } else {
    return React.createElement("iframe", {
                height: "0",
                src: "https://www.upward.net/search/u_convert.fsn?aid=NjE5NjE%3D",
                width: "0"
              });
  }
}

var make = WebComponents_JobcasePixel;

exports.deployEnv = deployEnv;
exports.make = make;
/* react Not a pure module */
